import React, { useState } from 'react';

function useRefineResultState(config) {
    const { initialFormState, formLabel, applyFilter } = config;

    const [formData, setFormData] = useState(initialFormState);

    const bindUpdateFormData = (e) => {
        updateFormData(e.target.name, e.target.value);
    };

    const bindUpdateFormDataNumber = (e) => {
        updateFormData(e.target.name, Number(e.target.value));
    };

    const updateFormData = (key, value) => {
        setFormData({
            ...formData,
            [key]: value,
        });
    };
    const updateFormDataBulk = (newFormData) => {
        setFormData({
            ...formData,
            ...newFormData,
        });
    };

    const submitForm = (e) => {
        e.preventDefault();
        applyFilter(formData);
    };

    const clearFilter = (key) => {
        let newFormData = {
            ...formData,
            [key]: initialFormState[key],
        };

        setFormData(newFormData);
        applyFilter(newFormData);
    };

    const clearAllFilters = () => {
        setFormData(initialFormState);
        applyFilter(initialFormState);
    };

    const getManagedActiveFilters = (rawFilters) => {
        let activeFilters = [];

        Object.entries(rawFilters).map(([key, value]) => {
            if (value) {
                activeFilters.push({
                    key: key,
                    label: formLabel[key],
                    value: value,
                });
            }
        });

        return activeFilters;
    };

    return {
        formData,
        bindUpdateFormData,
        bindUpdateFormDataNumber,
        updateFormData,
        updateFormDataBulk,
        clearFilter,
        clearAllFilters,
        submitForm,
        getManagedActiveFilters,
    };
}

export default useRefineResultState;
